import HttpServerConfig from "../../../common/HttpServerConfig";
import { md5 } from "../../../common/netWork/base";
import Util from "../../../utils/Util";
import LoadLocalXJMind from "../tools/mapfile/LoadLocalXJMind";
import HistoryIndex from "./HistoryIndex";
import HistoryIndexCell from "./HistoryIndexCell";
if (
  typeof navigator === "object" &&
  typeof navigator.userAgent === "string" &&
  navigator.userAgent.indexOf("Electron") >= 0
) {
  var { ipcRenderer } = window.require("electron");
  // var ipcRenderer = window.ipcRenderer
}

class SaveMindRouter {
    constructor(appPath = "") {
        this.isElectron = true;
        this.HistortFolderName = "/xjhistory"
        this.FileSeparator = "/"
        this.appPath = LoadLocalXJMind.appPath;
        this.rootPath = "";
        this.setSeparator()
    }

    setSeparator() {
        let platform = navigator.platform.toLowerCase()
        let isWindows = platform.indexOf('win32') > -1 || platform.indexOf('win64') > -1
        if (isWindows) {
            this.FileSeparator = "\\"
            this.HistortFolderName = this.HistortFolderName.replaceAll("/", this.FileSeparator)
        } else {
            this.FileSeparator = "/"
        }
        this.rootPath = this.appPath + this.HistortFolderName
    }

    saveMindContent(rootId, sheetId, content, isShowEditHistoryView) {
        let name = rootId
        let nameIndex = rootId
        let time = Util.getCurrentTime()
        if (sheetId != "" && sheetId != null) {
            name = name + "_" + sheetId
            nameIndex = nameIndex + "_" + sheetId
        }
        name = name + "_" + time + ".json"
        nameIndex = nameIndex + ".json"
        let cell = new HistoryIndexCell()
        cell.time = time
        cell.fileName = name
        cell.md5 = md5(content)
        let that = this        
        this.loadJson(this.rootPath + this.FileSeparator + nameIndex).then((data) => {
            let historyIndex = new HistoryIndex()
            if (data != null && data.length > 0) {
                let json = data;
                historyIndex = historyIndex.format(json)
            }
            if (historyIndex.data.length > 0) {
                for (let index = 0; index < historyIndex.data.length; index++) {
                    const historyCell = historyIndex.data[index];
                    if (historyCell.md5 == cell.md5) {
                        return
                    }
                }
            }
            
            historyIndex.data.push(cell)

            let contentJson = historyIndex.getContentJson()
            that.saveLocalContent(that.rootPath, nameIndex, contentJson)
            
            that.saveLocalContent(that.rootPath, name,  content)
        })
    }

    getMindHistoryIndex(rootId, sheetId) {//HistoryIndex
        let nameIndex = rootId
        if (sheetId != "" && sheetId != null) {
            nameIndex = nameIndex + "_" + sheetId
        }
        nameIndex = nameIndex + ".json"
        let that = this
        return new Promise(async resolve => {
            try {
                this.loadJson(this.rootPath + this.FileSeparator + nameIndex).then((data) => {
                    let historyIndex = new HistoryIndex()
                    if (data != null && data.length > 0) {
                        let json = data;
                        historyIndex = historyIndex.format(json)
                    }
                    resolve(historyIndex)
                })
            } catch (error) {
                console.log("loadJson error: ", error);
                resolve(new HistoryIndex())
            }
            
        });
    }

    removeFile(rootId, sheetId, fileName) {
        let nameIndex = rootId
        let time = Util.getCurrentTime()
        if (sheetId != "" && sheetId != null) {
            nameIndex = nameIndex + "_" + sheetId
        }
        nameIndex = nameIndex + ".json"
        let that = this
        return new Promise(async resolve => {
            this.loadJson(this.rootPath + this.FileSeparator + nameIndex).then((data) => {
                let historyIndex = new HistoryIndex()
                if (data != null && data.length > 0) {
                    let json = data;
                    historyIndex = historyIndex.format(json)
                }
                if (historyIndex.data.length > 0) {
                    for (let index = 0; index < historyIndex.data.length; index++) {
                        const historyCell = historyIndex.data[index];
                        if (historyCell.fileName == fileName) {
                            historyIndex.data.splice(index, 1);
                            break
                        }
                    }
                }

                let contentJson = historyIndex.getContentJson()
                that.saveLocalContent(that.rootPath, nameIndex, contentJson)            
                that.deleteFile(that.rootPath + that.FileSeparator + fileName).then((data) => {
                    resolve(data)
                })
            })
        })
    }

    deleteFile(filePath) {
        var that = this
        return new Promise(async resolve => {
            try {      
                console.log("deleteFile file: ", filePath);              
                const result = await ipcRenderer.invoke('delete-file', filePath)
                let data = {success: result.success, message: result.message}          
                resolve(data)
            } catch (error) {
                console.log("deleteFile error: ", error);                
                resolve({success: false, message: error.message})
            }
        });        
    }

    getHistoryContent(fileName) {
        let that = this
        return new Promise(async resolve => {
            try {
                this.loadJson(this.rootPath + this.FileSeparator + fileName).then((data) => {
                    resolve(data)
                })
            } catch (error) {
                console.log("loadJson error: ", error);
                resolve("")
            }
            
        });
    }

    existsLocalFile(path) {
        var fs = window.require('fs');
        let e = fs.existsSync(path)
        return e
    }

    saveLocalContent(path, name, content) {
        let that = this;
        return new Promise(resolve => {
            if (path == null) {
                resolve(false)
                return 
            }
            var fs = window.require('fs');            
            if (name == null || name.length == 0) {
                fs.writeFile(path, content, function (err) {
                    if (err != null) {
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                });
            } else {
                this.createFolder(path);
                fs.writeFile(path + that.FileSeparator + name, content, function (err) {
                    if (err != null) {
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                });
            }
        })
    }

    loadJson(jsonpath) {
        let that = this
        return new Promise(async resolve => {
            try {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', HttpServerConfig.getLocalPathPrefix(jsonpath, that.appPath), true);
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        var fr = new FileReader();
                        fr.readAsText(xhr.response, "utf-8");
                        fr.addEventListener("loadend",(e) => {
                            var json = e.target.result;
                            resolve(json)
                        },false);
                    } else {
                        console.log("xhr.response xhr.status - ", xhr.status);
                        resolve("")
                    }
                };
                
                
                xhr.onerror = (error) => {
                    console.log("xhr.response error - ", error);
                    resolve("")
                };
                xhr.send();
            } catch (error) {
                console.log("loadJson error: ", error);
                resolve("")
            }
            
        });
    }

    createFolder(dirpath, dirname) {
        var fs = window.require('fs');
        var path = window.require('path');
        if (typeof dirname === "undefined") {
          if (fs.existsSync(dirpath)) {
          } else {
            this.createFolder(dirpath, path.dirname(dirpath));
          }
        } else {
          if (dirname !== path.dirname(dirpath)) {
            this.createFolder(dirpath);
            return;
          }
          if (fs.existsSync(dirname)) {
            fs.mkdirSync(dirpath,{recursive:true})
          } else {
            this.createFolder(dirname, path.dirname(dirname));
            fs.mkdirSync(dirpath,{recursive:true});
          }
        }
    }
}

export default SaveMindRouter